import { Component, Type, ViewChild } from '@angular/core';

import { SideBarService } from '../core/services/side-bar/side-bar.service';
import { RunnerComponent } from '../runner/runner.component';
import { SideBarDirective } from './side-bar.directive';

@Component({
  selector: 'side-bar',
  standalone: true,
  imports: [
    SideBarDirective,
    RunnerComponent
  ],
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
// Uses Dynamic Component Loader See https://angular.io/guide/dynamic-component-loader
export class SideBarComponent {
  @ViewChild(SideBarDirective, { static: true }) sideBarHost!: SideBarDirective;

  constructor(sideBarService: SideBarService) { 
    sideBarService.sideBarComponentLoad$.subscribe((type) => this.openSideBar(type));
  }

  loadComponent(type: Type<unknown>) {
    const viewContainerRef = this.sideBarHost.viewContainerRef;

    viewContainerRef.clear();

    viewContainerRef.createComponent(type);
  }

  openSideBar(type: Type<unknown>) {
    this.loadComponent(type);
  }
}
